// extracted by mini-css-extract-plugin
module.exports = {"container":"CondensedList_container__MbufV","label":"CondensedList_label__l6rhD","list":"CondensedList_list__U7WVG"};